import React from "react";

export default class DThomePlaceholder extends React.PureComponent {
  render() {
    return (
      <div className="store-placeholder">
        <style>
          {`
            @keyframes shimmerAnimation {
              0% {
                background-position: -468px 0;
              }
              100% {
                background-position: 468px 0;
              }
            }
            .banner-placeholder {
              height: 200px;
              background-color: #e0e0e0;
              position: relative;
              margin-bottom: 15px;
              overflow: hidden;
              background-image: linear-gradient(
                to right,
                #e0e0e0 0%,
                #f5f5f5 20%,
                #e0e0e0 40%,
                #e0e0e0 100%
              );
              background-repeat: no-repeat;
              background-size: 1000px 200px;
              animation-duration: 1.5s;
              animation-fill-mode: forwards;
              animation-iteration-count: infinite;
              animation-name: shimmerAnimation;
              animation-timing-function: linear;
            } 
          `}
        </style>
        <div className="banner-placeholder" />
        <div className="banner-placeholder" />
        <div className="banner-placeholder" />
        <div className="banner-placeholder" />
        <div className="banner-placeholder" />
      </div>
    );
  }
}
